<template>
  <el-cascader
    class="width-200"
    v-model="orgId"
    :options="orgOptions"
    :props="{checkStrictly: true}"
    clearable
    placeholder="所有部门"
    @change="changeFn"
  >
  </el-cascader>
</template>

<script>
import { GetOrgTree } from '@/api/customer';

export default {
  name: 'FilterOrganization',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      orgId: [],
      orgOptions: []
    };
  },
  created() {
    this.getOrgTree();
  },
  methods: {
    changeFn() {
      this.$emit('change', {
        type: 'organization',
        value: this.orgId.length ? this.orgId[this.orgId.length - 1] : 0
      });
    },
    getOrgTree() {
      GetOrgTree().then(res => {
        if (res.data.list.length) {
          res.data.list[0].child.map(item => {
            item.label = item.name;
            item.value = item.id;

            if (item.child.length) {
              item.children = item.child;

              item.children.map(subItem => {
                subItem.label = subItem.name;
                subItem.value = subItem.id;

                delete subItem.child;
              });
            } else {
              delete item.child;
            }
          });
          this.orgOptions = res.data.list[0].child;
          this.orgId = this.value;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
